import React from 'react';
import { WhatsAppIcon } from './icons';

// Fixed bottom action bar (replaces the old header top-bar): always-available
// Bel / WhatsApp / E-mail. Especially handy on mobile.
const WHATSAPP_NUMBER = '31616136942';

const StickyContactBar = () => {
  return (
    <div className="artwer-sticky-bar">
      <a className="artwer-sticky-bar__btn artwer-sticky-bar__btn--call" href="tel:+31616136942">
        <span className="icon-call" /><span className="lbl">Bellen</span>
      </a>
      <a
        className="artwer-sticky-bar__btn artwer-sticky-bar__btn--wa"
        href={`https://wa.me/${WHATSAPP_NUMBER}`}
        target="_blank"
        rel="noreferrer"
      >
        <WhatsAppIcon /><span className="lbl">WhatsApp</span>
      </a>
      <a className="artwer-sticky-bar__btn artwer-sticky-bar__btn--mail" href="mailto:info@art-wer.nl">
        <span className="icon-envelope" /><span className="lbl">E-mail</span>
      </a>
    </div>
  );
};

export default StickyContactBar;
